<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="8" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name === 'xs' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-form ref="registrationSignature">
          <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
            <v-col cols="12" class="pb-0">
              <div class="text-md-h4 text-h5" :style="textColor">Review and Sign</div>
            </v-col>
            <v-col cols="12" class="pb-1">
              <div class="text-subtitle-2 font-italic">By signing the document on the next page you agree that all information is correct and you are authorized to sign documents.</div>
            </v-col>

            <v-col cols="12" class="mt-8">
              <v-text-field
                ref="companyName"
                outlined
                label="*Company Name"
                class="rounded-lg"
                :hide-details="hideCompanyNameValidationText"
                v-model="legalName"
                :rules="[rules.required]"
                validate-on-blur
                @blur="() => $refs.registrationSignature.resetValidation()"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                ref="fullName"
                outlined
                label="*Signer's Name"
                class="rounded-lg"
                :hide-details="hideFullNameValidationText"
                v-model="signature.name"
                :rules="[rules.fullName]"
                validate-on-blur
                @blur="() => $refs.registrationSignature.resetValidation()"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                ref="title"
                outlined
                label="*Signer's Title"
                class="rounded-lg"
                :hide-details="hideTitleValidationText"
                v-model="signature.title"
                :rules="[rules.required]"
                validate-on-blur
                @blur="() => $refs.registrationSignature.resetValidation()"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                ref="email"
                outlined
                label="*Signer's Email"
                class="rounded-lg"
                :hide-details="hideEmailValidationText"
                v-model="signature.email"
                :rules="[rules.email]"
                validate-on-blur
                @blur="() => $refs.registrationSignature.resetValidation()"
              ></v-text-field>
            </v-col>

            <!-- <v-col cols="12" class="mb-8">
              <v-btn
                color="primary"
                @click="signDocuments"
                :loading="btnSignAndReviewLoading"
              >
                {{ btnSignDocumentsLabel }} <v-icon v-if="btnSignDocumentsLabel == 'Email Signature Request'" right>mdi-email-fast</v-icon>
              </v-btn>
            </v-col> -->

            <v-col cols="12" class="mb-8" v-if="SignatureEmailMatch == false">
              <v-btn
                color="primary"
                @click="sendSignatureRequest"
                :loading="btnSignAndReviewLoading"
              >
                Email Signature Request
                <v-icon right>mdi-email-fast</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" class="mb-8" v-if="SignatureEmailMatch">
              <v-btn
                color="primary"
                @click="signDocuments"
                :loading="btnSignAndReviewLoading"
              >
                Proceed To Signing
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
export default {
  name: 'StepNine',
  data: () => ({
    signatureLocal: {
      name: null,
      title: null,
      email: null,
      signingDate: null,
    },
    rules: {
      required: (value) => !!value || 'Required',
      fullName: (value) => {
        let firstAndLast = [];
        if (value !== null) {
          firstAndLast = value.split(' ');
        }
        if (firstAndLast.length <= 1) {
          return 'First and Last required';
        }
        return true;
      },
      // eslint-disable-next-line max-len
      email: (value) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Email is invalid',
    },
    hideEmailValidationText: true,
    hideFullNameValidationText: true,
    hideTitleValidationText: true,
    hideCompanyNameValidationText: true,
  }),
  mounted() {
    this.signatureLocal.signingDate = new Date().toLocaleString();
  },
  computed: {
    // btnSignDocumentsLabel() {
    //   if (this.SignatureEmailMatch === false && this.rules.email(this.signature.email) === true) {
    //     return 'Email Signature Request';
    //   }
    //   return 'Proceed To Signing';
    // },
    btnSignAndReviewLoading() {
      return this.$store.state.btnSignAndReviewLoading;
    },
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    signature: {
      get() {
        if (this.$store.state.prospectPacket.signature) {
          return this.$store.state.prospectPacket.signature;
        }
        return this.signatureLocal;
      },
      set(value) {
        this.$store.commit('updateProspectSignature', value);
      },
    },
    legalName() {
      return this.$store.state.prospectPacket.companyInfo.legalName;
    },
    SignatureEmailMatch() {
      const email = this.signature.email ? this.signature.email.toLowerCase() : '';
      if (email !== this.$store.state.prospectPacket.loggedInUser.email.toLowerCase()) {
        return false;
      }

      return true;
    },
  },
  methods: {
    signDocuments() {
      if (this.$refs.registrationSignature.validate()) {
        this.$store.commit('updateSignatureRequestEmail', null);
        this.signature.signingDate = new Date().toLocaleString();
        this.$store.dispatch('updatePacketInfo').then(() => {
          this.$store.dispatch('invokeSignRegistrationDocuments').then((resp) => {
            if (this.SignatureEmailMatch) {
              const { documentId } = resp;
              this.$store.commit('updateDocSignDialog', false);
              this.$store.commit('updateDocSignEmail', this.signature.email);
              this.$router.push({ name: 'Sign', params: { id: documentId } });
            }
          });
        });
      } else if (!this.$refs.email.valid) {
        this.hideEmailValidationText = false;
      } else if (!this.$refs.title.valid) {
        this.hideTitleValidationText = false;
      } else if (!this.$refs.fullName.valid) {
        this.hideFullNameValidationText = false;
      } else if (!this.$refs.companyName.valid) {
        this.hideCompanyNameValidationText = false;
      } else {
        this.hideEmailValidationText = true;
        this.hideTitleValidationText = true;
        this.hideFullNameValidationText = true;
        this.hideCompanyNameValidationText = true;
      }
    },
    sendSignatureRequest() {
      if (this.$refs.registrationSignature.validate()) {
        this.$store.commit('updateSignatureRequestEmail', this.signature.email);
        this.signature.signingDate = new Date().toLocaleString();
        this.$store.dispatch('updatePacketInfo').then(() => {
          this.$store.dispatch('invokeSignRegistrationDocuments');
        });
      } else if (!this.$refs.email.valid) {
        this.hideEmailValidationText = false;
      } else if (!this.$refs.title.valid) {
        this.hideTitleValidationText = false;
      } else if (!this.$refs.fullName.valid) {
        this.hideFullNameValidationText = false;
      } else if (!this.$refs.companyName.valid) {
        this.hideCompanyNameValidationText = false;
      } else {
        this.hideEmailValidationText = true;
        this.hideTitleValidationText = true;
        this.hideFullNameValidationText = true;
        this.hideCompanyNameValidationText = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
